import React, { FC } from 'react';
import { ModalRouteProps } from 'context/ModalRouter';
import { parseQueryParamToNumbers } from 'utils/url';
import Modal from 'components/shared/Modal';
import PostsSelectionContainer from 'components/workflowOptions/postsSelection/PostsSelectionContainer';
import PostsSelection from 'components/workflowOptions/PostsSelection';
import useSchedulePostsContainer from 'components/workflowOptions/schedulePosts/SchedulePosts.hooks';
import PostsSchedulingResults from 'components/workflowOptions/schedulePosts/PostsSchedulingResults';
import { Button } from '@kontentino/ui';
import { usePostsContainer } from 'components/posts/context';
import ScheduleWorkflowButton from 'app/modules/posts/modules/detail/components/postModalFooter/ScheduleWorkflowButton';
import { useTranslation } from 'react-i18next';

type Props = ModalRouteProps;

const SchedulePosts: FC<Props> = (props) => {
  const initialPostsIds = getInitialPostsIds();
  const postsContainer = usePostsContainer();
  const container = useSchedulePostsContainer({
    initialPostsIds,
    ...props,
  });
  const { t } = useTranslation();

  function getInitialPostsIds() {
    let posts = props.modalManager.getQueryParameter('posts');

    return parseQueryParamToNumbers(posts);
  }

  return (
    <Modal
      size="lg"
      isLoading={container.isLoadingValidation}
      modalManager={{
        ...props.modalManager,
        close: container.closeModal,
      }}
    >
      <Modal.Header title={t('schedulePosts')} />
      {!container.scheduleResponse && (
        <>
          <Modal.Content>
            <PostsSelectionContainer
              allowedStatuses={container.allowedStatuses}
              selectedStatuses={container.selectedStatuses}
            >
              {(params) => (
                <PostsSelection
                  allowedStatuses={container.allowedStatuses}
                  selectedStatuses={container.selectedStatuses}
                  onSelectPostStatus={container.togglePostStatus}
                  disabledPosts={container.disabledPosts}
                  warningMessages={container.invalidPostsMessages}
                  posts={params.posts}
                  onSelectPost={container.togglePost}
                  selectedPosts={container.selectedPosts}
                  onSelectAllPosts={() => container.selectAllPosts()}
                  onUnselectAllPosts={() => container.unselectAllPosts()}
                />
              )}
            </PostsSelectionContainer>
          </Modal.Content>
          <Modal.Footer>
            <div data-name="workflow-options-dropdown_schedule_submit">
              <ScheduleWorkflowButton
                isLoading={container.isScheduling}
                isDisabled={
                  container.isLoadingValidation ||
                  container.selectedPosts.length === 0 ||
                  !container.canSchedule
                }
                onSchedule={(scheduleMethod) => {
                  container.onSubmit(
                    scheduleMethod === 'exportInAdvance' ? 'export' : 'publish',
                  );
                }}
                schedulingOptions={[
                  {
                    option: 'exportInAdvance',
                    disabled: !container.canExportInAdvance,
                  },
                  {
                    option: 'publishNow',
                    disabled: !container.canPublishNow,
                  },
                ]}
                post={container.selectedPosts}
              />
            </div>
          </Modal.Footer>
        </>
      )}
      {container.scheduleResponse && (
        <>
          <Modal.Content>
            <PostsSchedulingResults
              scheduleResponse={container.scheduleResponse}
              scheduleChosenMethod={container.scheduleChosenMethod}
              posts={container.posts}
            />
          </Modal.Content>
          <Modal.Footer>
            <Button
              onClick={() => {
                container.closeModal();
                postsContainer.clearSelectedPosts();
              }}
            >
              {t('close')}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default SchedulePosts;
